import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { AppResource } from "../types/resource.types";

const routesNotHaveReloadBtn = [
  `/${AppResource.chat}`,
  `/${AppResource.terms}`,
  `/${AppResource.settings}`,
  `/${AppResource.courtAvailabilities}`,
  `/${AppResource.courtsSlotsCalendar}`,
  `/${AppResource.brandsDeliveryMethods}`,
  `/${AppResource.orderPreview}`,
  `/${AppResource.brandsMedia}`,
  `/${AppResource.bulkProductsCreate}`,
];

const useHideReloadIcon = (): any => {
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      const raReloadBtn = document.querySelector('[aria-label="Refresh"]');
      if (routesNotHaveReloadBtn.some((route: string) => location.pathname.includes(route)))
        raReloadBtn?.classList.add("hideReloadBtn");
      else raReloadBtn?.classList.remove("hideReloadBtn");
    }, 0);
  }, [location]);

  return;
};

export default useHideReloadIcon;
